import Loading from "components/loading/loading.component";
import React, { useState } from "react";
import { IFileUploaderProps } from "./FileUplaoder.interface";

const FileUploader: React.FC<IFileUploaderProps> = ({
  onUpload,
  file,
  type,
  isUploading,
}) => {
  const [dragging, setDragging] = useState<boolean>(false);
  const [hasError, setHasError] = useState<boolean>(false);

  const handleDragEnter = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setDragging(true);
  };

  const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setDragging(false);
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setDragging(true);
  };

  const handleDrop = async (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setDragging(false);
    setHasError(false);

    const file = e.dataTransfer.files[0];
    let uploadedType = file.name.split(".").pop();

    if (`.${uploadedType}` === type) {
      const formData = new FormData();
      formData.append("file", file);
      onUpload(formData);
    } else {
      setHasError(true);
    }
  };

  const handleFilePicked = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const fileInput = event.target;
    if (fileInput.files && fileInput.files.length > 0) {
      const selectedFile = fileInput.files[0];
      let uploadedType = selectedFile.name.split(".").pop();

      if (`.${uploadedType}` === type) {
        const formData = new FormData();
        formData.append("file", selectedFile);
        onUpload(formData);
      } else {
        setHasError(true);
      }
    }
  };

  return (
    <>
      <label htmlFor="csv">
        <div
          className={`border border-dashed rounded-lg  h-[145px] ${
            dragging ? "bg-slate-500" : "bg-background"
          }`}
          onDragEnter={handleDragEnter}
          onDragLeave={handleDragLeave}
          onDragOver={handleDragOver}
          onDrop={handleDrop}
        >
          <input
            id="csv"
            type="file"
            name="csv"
            accept={type}
            onChange={(data) => handleFilePicked(data)}
            className="hidden"
          />
          {!file ? (
            <div className="py-[48px] px-[72px]">
              <div className="flex justify-center ">
                <svg
                  width="21"
                  height="16"
                  viewBox="0 0 21 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.4997 10.9695V13.084C18.4997 13.6195 18.052 14.0535 17.4997 14.0535H3.49995C2.94763 14.0535 2.49997 13.6195 2.49997 13.084V10.9695C2.49997 10.434 2.05231 10 1.49998 10C0.947659 10 0.5 10.434 0.5 10.9695V13.4117C0.5 14.8411 1.69531 16 3.16962 16H17.8304C19.3047 16 20.5 14.8411 20.5 13.4117V10.9695C20.5 10.434 20.0523 10 19.5 10C18.9477 10 18.5 10.434 18.5 10.9695H18.4997Z"
                    fill="#529C82"
                  />
                  <path
                    d="M8.7671 3.24531L11.4749 3.24531L11.4749 11.2031C11.4749 11.9508 10.8688 12.5571 10.1208 12.5571C9.37312 12.5571 8.76677 11.9511 8.76677 11.2031L8.76677 3.24498L8.7671 3.24531Z"
                    fill="#529C82"
                  />
                  <path
                    d="M3.89833 7.66533C4.42723 8.19424 5.28447 8.19424 5.81305 7.66533L10.1214 3.35695L14.4298 7.66533C14.9587 8.19424 15.816 8.19424 16.3445 7.66533C16.8734 7.13642 16.8734 6.27918 16.3445 5.75061L10.9284 0.334434C10.4825 -0.111397 9.76 -0.111397 9.31417 0.334434L3.89799 5.75061C3.36909 6.27951 3.36909 7.13675 3.89799 7.66533L3.89833 7.66533Z"
                    fill="#529C82"
                  />
                </svg>
              </div>
              <span className="flex items-center justify-center px-[15px] text-center">
                <span className="text-[12px] leading-4  text-headerBlack">
                  drag and drop a .csv file or
                  <span className="px-1 font-bold text-green">
                    select a file
                  </span>
                  from your computer
                </span>
              </span>
              {isUploading && (
                <span className="flex items-center justify-center px-[15px] text-center mt-3">
                  <span className="leading-4 text-md text-red">
                    <Loading text="Uploading file ..." />
                  </span>
                </span>
              )}
              {hasError && (
                <span className="flex items-center justify-center px-[15px] text-center mt-3">
                  <span className="text-[10px] leading-4  text-red">
                    File format not supported
                  </span>
                </span>
              )}
            </div>
          ) : (
            <div className="py-[48px] px-[72px]">
              <div className="flex justify-center ">
                <svg
                  width={25}
                  height={30}
                  viewBox="0 0 25 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24.1729 6.70431L17.6622 0.187289C17.6029 0.127892 17.5325 0.0807739 17.455 0.0486349C17.3775 0.0164959 17.2945 -3.15552e-05 17.2106 4.52292e-08H2.22179C1.80251 0.000454536 1.40054 0.167213 1.10407 0.463686C0.807593 0.760159 0.640835 1.16213 0.640381 1.58141V28.4186C0.640835 28.8379 0.807593 29.2398 1.10407 29.5363C1.40054 29.8328 1.80251 29.9995 2.22179 30H22.7782C23.1975 29.9995 23.5995 29.8328 23.8959 29.5363C24.1924 29.2398 24.3592 28.8379 24.3596 28.4186V7.15532C24.3596 6.98619 24.2924 6.824 24.1729 6.70431ZM17.8489 2.18036L22.1813 6.51702H18.1537C18.0729 6.5169 17.9954 6.48475 17.9383 6.42761C17.8811 6.37047 17.849 6.29301 17.8489 6.21221V2.18036ZM22.7782 28.7234H2.22179C2.14099 28.7233 2.06353 28.6911 2.00639 28.634C1.94925 28.5769 1.9171 28.4994 1.91698 28.4186V1.58141C1.9171 1.5006 1.94925 1.42314 2.00639 1.36601C2.06353 1.30887 2.14099 1.27672 2.22179 1.2766H16.5723V6.21218C16.5727 6.63146 16.7395 7.03344 17.0359 7.32992C17.3324 7.6264 17.7344 7.79316 18.1537 7.79362H23.083V28.4186C23.0829 28.4994 23.0508 28.5769 22.9936 28.634C22.9365 28.6911 22.859 28.7233 22.7782 28.7234Z"
                    fill="#3A3A3A"
                  />
                  <path
                    d="M8.24611 20.072C7.69144 20.072 7.21677 19.9547 6.82211 19.72C6.42744 19.4853 6.12344 19.152 5.91011 18.72C5.70211 18.288 5.59811 17.7733 5.59811 17.176C5.59811 16.728 5.65677 16.328 5.77411 15.976C5.89677 15.6187 6.07011 15.3173 6.29411 15.072C6.52344 14.8213 6.80344 14.6293 7.13411 14.496C7.46477 14.3573 7.83544 14.288 8.24611 14.288C8.57677 14.288 8.89144 14.336 9.19011 14.432C9.48877 14.5227 9.74744 14.6587 9.96611 14.84C10.0354 14.8933 10.0808 14.9547 10.1021 15.024C10.1288 15.088 10.1314 15.152 10.1101 15.216C10.0941 15.2747 10.0621 15.3253 10.0141 15.368C9.97144 15.4053 9.91811 15.424 9.85411 15.424C9.79011 15.424 9.71811 15.3973 9.63811 15.344C9.44611 15.1893 9.23544 15.0747 9.00611 15C8.77677 14.9253 8.52877 14.888 8.26211 14.888C7.84077 14.888 7.48344 14.9787 7.19011 15.16C6.89677 15.336 6.67544 15.5947 6.52611 15.936C6.37677 16.2773 6.30211 16.6907 6.30211 17.176C6.30211 17.6613 6.37677 18.0773 6.52611 18.424C6.67544 18.7653 6.89677 19.0267 7.19011 19.208C7.48344 19.384 7.84077 19.472 8.26211 19.472C8.52344 19.472 8.77144 19.4347 9.00611 19.36C9.24077 19.28 9.45677 19.1627 9.65411 19.008C9.73411 18.9547 9.80611 18.9307 9.87011 18.936C9.93411 18.936 9.98744 18.9547 10.0301 18.992C10.0728 19.0293 10.1021 19.0773 10.1181 19.136C10.1394 19.1947 10.1394 19.256 10.1181 19.32C10.1021 19.384 10.0621 19.44 9.99811 19.488C9.77411 19.68 9.51011 19.8267 9.20611 19.928C8.90744 20.024 8.58744 20.072 8.24611 20.072ZM12.9192 20.072C12.6685 20.072 12.4232 20.0507 12.1832 20.008C11.9432 19.9653 11.7192 19.904 11.5112 19.824C11.3085 19.744 11.1245 19.6427 10.9592 19.52C10.8952 19.472 10.8498 19.4187 10.8232 19.36C10.8018 19.296 10.7965 19.2347 10.8072 19.176C10.8232 19.112 10.8498 19.0587 10.8872 19.016C10.9298 18.9733 10.9805 18.9493 11.0392 18.944C11.0978 18.9387 11.1618 18.9573 11.2312 19C11.4712 19.1707 11.7272 19.296 11.9992 19.376C12.2712 19.4507 12.5778 19.488 12.9192 19.488C13.3992 19.488 13.7538 19.4 13.9832 19.224C14.2178 19.0427 14.3352 18.8053 14.3352 18.512C14.3352 18.272 14.2498 18.0853 14.0792 17.952C13.9138 17.8133 13.6338 17.704 13.2392 17.624L12.4072 17.456C11.9058 17.3493 11.5298 17.176 11.2792 16.936C11.0338 16.6907 10.9112 16.3653 10.9112 15.96C10.9112 15.7093 10.9618 15.4827 11.0632 15.28C11.1645 15.072 11.3058 14.896 11.4872 14.752C11.6685 14.6027 11.8845 14.488 12.1352 14.408C12.3858 14.328 12.6632 14.288 12.9672 14.288C13.3032 14.288 13.6152 14.336 13.9032 14.432C14.1965 14.5227 14.4605 14.6613 14.6952 14.848C14.7538 14.896 14.7938 14.952 14.8152 15.016C14.8365 15.0747 14.8392 15.1333 14.8232 15.192C14.8072 15.2453 14.7778 15.2907 14.7352 15.328C14.6978 15.3653 14.6472 15.3867 14.5832 15.392C14.5245 15.3973 14.4578 15.376 14.3832 15.328C14.1698 15.168 13.9485 15.0533 13.7192 14.984C13.4898 14.9093 13.2365 14.872 12.9592 14.872C12.6765 14.872 12.4312 14.9147 12.2232 15C12.0205 15.0853 11.8605 15.2107 11.7432 15.376C11.6312 15.536 11.5752 15.7227 11.5752 15.936C11.5752 16.192 11.6525 16.3947 11.8072 16.544C11.9672 16.6933 12.2258 16.8027 12.5832 16.872L13.4152 17.048C13.9538 17.16 14.3512 17.3307 14.6072 17.56C14.8685 17.784 14.9992 18.0907 14.9992 18.48C14.9992 18.7147 14.9512 18.9307 14.8552 19.128C14.7592 19.3253 14.6205 19.496 14.4392 19.64C14.2578 19.7787 14.0392 19.8853 13.7832 19.96C13.5272 20.0347 13.2392 20.072 12.9192 20.072ZM17.9951 20.056C17.8938 20.056 17.8111 20.032 17.7471 19.984C17.6831 19.936 17.6324 19.864 17.5951 19.768L15.3951 14.736C15.3578 14.6453 15.3471 14.5707 15.3631 14.512C15.3791 14.448 15.4138 14.3973 15.4671 14.36C15.5258 14.3227 15.5924 14.304 15.6671 14.304C15.7684 14.304 15.8431 14.328 15.8911 14.376C15.9444 14.4187 15.9871 14.4827 16.0191 14.568L18.1311 19.472H17.8751L19.9791 14.56C20.0164 14.48 20.0618 14.4187 20.1151 14.376C20.1684 14.328 20.2431 14.304 20.3391 14.304C20.4138 14.304 20.4751 14.3227 20.5231 14.36C20.5764 14.3973 20.6084 14.448 20.6191 14.512C20.6351 14.576 20.6244 14.6507 20.5871 14.736L18.3871 19.768C18.3498 19.864 18.2991 19.936 18.2351 19.984C18.1764 20.032 18.0964 20.056 17.9951 20.056Z"
                    fill="#3A3A3A"
                  />
                </svg>
              </div>
              {/* <span className="flex justify-center">{file.name}</span> */}
              <span className="flex items-center justify-center text-green px-[19px] text-center">
                <span className="text-[10px] leading-4 py-1 px-1">Replace</span>
                <span>
                  <svg
                    width={10}
                    height={8}
                    viewBox="0 0 10 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_483_82154)">
                      <path
                        d="M9.4443 1.39912C9.44067 1.35467 9.406 1.31714 9.36808 1.29334L6.29667 0.00716666C6.25533 -0.00293221 6.21926 -0.00440649 6.18496 0.0163072C6.15067 0.0369473 6.12674 0.0747627 6.11667 0.115822L5.8437 3.42073C5.84733 3.46526 5.86482 3.51317 5.90274 3.53691C5.94926 3.55541 5.99919 3.56035 6.042 3.53455L7.07111 2.91336C7.49785 3.67129 7.61045 4.54886 7.40993 5.3937C7.194 6.27119 6.63852 7.01497 5.84963 7.49117C5.78956 7.52743 5.76415 7.60115 5.80052 7.66086C5.83696 7.72064 5.91963 7.74069 5.97963 7.7045L7.12015 7.01608C7.96052 6.50877 8.56037 5.70308 8.78459 4.76233C9.01578 3.85226 8.88393 2.90466 8.42593 2.09542L9.38637 1.51566C9.42067 1.49502 9.44793 1.44349 9.4443 1.39897V1.39912Z"
                        fill="#529C82"
                      />
                      <path
                        d="M4.15072 0.508756C4.21079 0.472488 4.2362 0.398774 4.19983 0.339065C4.16338 0.279283 4.08079 0.259233 4.02072 0.295353L2.8802 0.983845C2.03983 1.49115 1.43998 2.29685 1.21583 3.23759C0.984496 4.14767 1.11642 5.09526 1.57442 5.9045L0.613977 6.48419C0.579607 6.50498 0.552422 6.55643 0.555977 6.60088C0.557903 6.62314 0.568274 6.64017 0.578718 6.6572C0.589088 6.6743 0.613236 6.69472 0.632199 6.70659L3.70361 7.99275C3.74501 8.00285 3.78101 8.0044 3.81538 7.98361C3.84968 7.96297 3.87361 7.92516 3.88368 7.8841L4.15664 4.57912C4.15294 4.53474 4.13553 4.48683 4.09761 4.46309C4.05109 4.44444 4.00116 4.4395 3.96687 4.46029L2.92931 5.08657C2.50242 4.32863 2.38983 3.45107 2.5905 2.60622C2.80635 1.72873 3.36183 0.984951 4.15072 0.508756Z"
                        fill="#529C82"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_483_82154">
                        <rect
                          width="8.88889"
                          height={8}
                          fill="white"
                          transform="translate(0.555664)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
              </span>
            </div>
          )}
        </div>
      </label>
    </>
  );
};

export default FileUploader;
